import { format } from 'date-fns';
import { Card, CardContent, Chip, Grid, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import { useFetch } from '../../../hooks/useFecth';

const InfoCard = ({ title, value, description }) => (
    <Card>
        <CardContent>
            <Typography variant="overline" color="text.secondary">
                {title}
            </Typography>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                {value || '--'}
            </Typography>
            {description && (
                <Typography variant="body2" color="text.secondary">
                    {description}
                </Typography>
            )}
        </CardContent>
    </Card>
);

export default function AdvertiserDashboard() {
    const { data: profile } = useFetch('/advertiser/profile');
    const { data: rescuesData } = useFetch('/advertiser/redemptions', {
        params: {
            perPage: 5,
        },
    });

    const rescues = rescuesData?.data ?? rescuesData ?? [];



    return (
        <Stack rowGap={3}>
            <Typography variant="h4" fontWeight="bold">
                Bem-vindo, {profile?.name || 'anunciante'}
            </Typography>
            <Typography color="text.secondary">
                Aqui você acompanha rapidamente os principais indicadores do seu negócio.
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <InfoCard title="Status" value={profile?.status ? 'Ativo' : 'Inativo'} description={profile?.businessName} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <InfoCard title="Cidade" value={`${profile?.city ?? ''} - ${profile?.state ?? ''}`} description={profile?.neighborhood} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <InfoCard title="Contato principal" value={profile?.responsibleName} description={profile?.responsibleEmail} />
                </Grid>
            </Grid>

            <Card>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography variant="h6">Últimos resgates</Typography>
                        <Chip label="Atualizado em tempo real" size="small" color="primary" variant="outlined" />
                    </Stack>
                    {rescues.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">
                            Nenhum resgate encontrado.
                        </Typography>
                    ) : (
                        <List>
                            {rescues?.map(rescue => (
                                <ListItem
                                    key={rescue.id}
                                    divider
                                    secondaryAction={
                                        <Typography variant="subtitle2">
                                            {rescue.saleValue ? `R$ ${Number(rescue.saleValue).toFixed(2)}` : '--'}
                                        </Typography>
                                    }
                                >
                                    <ListItemText
                                        primary={`Código ${rescue.code}`}
                                        secondary={
                                            <>
                                                <Typography variant="caption" color="text.secondary">
                                                    {rescue.createdAt ? format(new Date(rescue.createdAt), 'dd/MM/yyyy HH:mm') : '--'}
                                                </Typography>
                                                <Chip
                                                    label={rescue.status || 'pendente'}
                                                    size="small"
                                                    sx={{ ml: 1 }}
                                                    color={rescue.status === 'VALIDATED' ? 'success' : 'default'}
                                                />
                                            </>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    )}
                </CardContent>
            </Card>
        </Stack>
    );
}

